<template>
  <div class="risk-profile">
    <div class="header-card">
      <!-- <div class="close-btn">
        <img src="@/assets/close.png" height="18" width="18" alt="close-icon" @click="close()">
      </div> -->
      <div class="header-card-text">
        <h4 class="cabin-family bold">About SIC / Future Africa Collective.</h4>
        <span class="sub-text fnt-14">Yearly Subscription Based platform:
          Annual Subscription is paid to Future Collective</span>
      </div>
    </div>
      <div class="risk-profile-body">
        <div class="">
          <p class="">When you join the sub-unit and from our partnership with Future
            collective, from here on out, every quarter, you should expect to receive five
            investment opportunities in companies run by some of Africa's best innovators. These
            world-class African innovators are leveraging technology and innovation to turn some
            of Africa's greatest challenges into global business opportunities. By backing these
            innovators you are helping us take power back from a capital stack that prioritizes
            privilege and prejudice over the progress over our people. If we succeed, together,
            our capital will fund innovation that becomes a true force for our continent's
            development.</p>

          <p class="">A few ground rules for our community:</p>

          <p class="">Everything we share with you is proprietary information and
            analysis about the businesses of our innovators. Please keep it confidential. Do not
            share this information with anyone. If you break this trust, you will be expelled from
            the collective. Remember that you can always refer new Collective members and we will
            fast track their prospective co-Investor applications.</p>

          <p class="">Every member of the collective must digitally sign our Future
            Africa Collective Membership Agreement to complete their onboarding process. Without
            this signed agreement, you cannot receive deal flow from us. Please it is very important
            that you read and sign it as it details our relationship with you as it concerns the
            collective. <strong>(This has been done for you by SIC)</strong></p>

          <p class="">Early-stage investments in innovative startups do not always pan
            out. Please keep in mind that the investments you make may fail for completely
            legitimate reasons. More importantly, no one - not even us - has any control over the
            timing of your exit. Investors sometimes wait between 8-14 years to exit their
            positions. Do not invest funds that you need immediately or you are not prepared
            to lose completely.</p>

          <p class="">Our investment activity happens on AngelList. Even if you haven't
            decided to invest in any businesses just yet, it is a good idea for you to create an
            AngelList investor profile as you will need to have an AngelList profile to make
            investments whenever you choose to. If you have any issues creating an investor profile
            on AngelList, kindly send us an email and we will walk you through it.
          <strong>(This has been done. You do not need create an  individual account).</strong></p>

          <p class="">Finally, you are in complete control of your Collective
            experience. This is your Collective. As we grow we will introduce platforms and programs
            to help you self organize, learn and connect with your fellow co-investors. We would
            also love to hear about amazing companies you think we should take a look at.</p>

          <p class="">“When I asked you to join me in this battle for the future of
            African venture capital, I mentioned that we stand at the precipice of a perfect storm
            that offers us an opportunity to redefine the future of Venture Capital - first in
            Africa, but ultimately all over the world. As we quickly approach the clear and present
            digital future COVID 19 has delivered to us, we must ensure that the doors of capital
            are not unfairly shut in their faces of African innovators on the account of a misplaced
            judgement of Africa's opportunity and risks. We must ensure that the decisions about
            which innovations are worthy of funding will not be made in small rooms far from Africa
            where people who look like us are not allowed. We must ensure that African capital can
            fund and reap returns from an African future” <strong>Iyin Aboyeji</strong></p>

          <p class="cabin-family">Thank you once again for co-investing with us.</p>
        </div>
         <button class="primary-btn btn btn-block mt-4" @click="close">Continue</button>
      </div>
  </div>
</template>

<script>
export default {
  props: ['message'],
  data() {
    return {
      q7: '',
      loading: false,
    };
  },
  methods: {
    close() {
      localStorage.setItem('angelinvestment-popup', true);
      this.$emit('close');
    },
  },
  mounted() {
    window.scrollTo(0, 0);
  },
};
</script>

<style lang="scss" scoped>
.risk-profile{
  min-height: 100vh;
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
  background-color: #F9F9F9;
  color: #000;
  &-body{
    text-align: left;
    padding: 1rem;
  }
}
.header-card-text{
  margin: .5rem auto;
}
.literacy-footer{
  position: relative;
  margin-top: 2rem;
  width: 100%;
}
p{
  margin-bottom: 0;
  margin-block-end: .5em;
  text-align: justify;
}
a{
  color: #EE0E4C;
}
</style>
